import { style } from "@vanilla-extract/css";
import pitchGraphic from "../../img/pitches/pitch-graphic.svg";
import { breakpoints } from "../../styles/breakpoints";
import { vars } from "../../styles/theme.css";

export const pitch = style({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  margin: "0 auto",
  borderRadius: `0 0 ${vars.radii.l} ${vars.radii.l}`,
  backgroundPosition: "top",
  backgroundRepeat: "no-repeat",
  backgroundSize: "850px auto",
  padding: `${vars.space.l} 0`,
  maxWidth: 1400,
  minHeight: 440,
  overflow: "hidden",
  selectors: {
    '&[data-sponsor="default"]': {
      backgroundImage: `url(${pitchGraphic})`,
    },
  },
  "@media": {
    [`screen and (min-width:${breakpoints[2]})`]: {
      gap: vars.space.s,
      borderRadius: vars.radii.l,
      backgroundSize: "1400px auto",
      padding: `${vars.space.m} ${vars.space.s}`,
      minHeight: 628,
    },
  },
});

const pitchRow = style({
  display: "flex",
  justifyContent: "space-evenly",
});

export const goalkeeperRow = style([
  pitchRow,
  {
    paddingInline: "20%",
    "@media": {
      [`screen and (min-width:${breakpoints[2]})`]: {
        paddingTop: vars.space.l,
      },
    },
  },
]);

export const defenderRow = style([
  pitchRow,
  {
    "@media": {
      [`screen and (min-width:${breakpoints[3]})`]: {
        paddingInline: "5%",
      },
      [`screen and (min-width:${breakpoints[6]})`]: {
        paddingInline: "10%",
      },
    },
  },
]);

export const midfielderRow = style([
  pitchRow,
  {
    "@media": {
      [`screen and (min-width:${breakpoints[5]})`]: {
        paddingInline: "0%",
      },
      [`screen and (min-width:${breakpoints[6]})`]: {
        paddingInline: "5%",
      },
    },
  },
]);

export const forwardsRow = style([
  pitchRow,
  {
    "@media": {
      [`screen and (min-width:${breakpoints[5]})`]: {
        paddingInline: "15%",
      },
    },
  },
]);
